// 랜딩페이지 한국어/영어 문구 사전. LandingPage.tsx/FreeTrialWidget.tsx가
// useLanguage()의 language 값으로 이 객체를 선택해 사용한다.

export const landingCopy = {
  ko: {
    meta: {
      title: 'ALT Generation - AI 이미지 대체텍스트 자동 생성',
      description: 'AI로 이미지 alt 텍스트를 자동 생성하세요. 웹 접근성 준수와 SEO를 동시에 해결하는 이미지 대체텍스트 자동화 서비스.',
    },
    notice: {
      badge: '공지',
      viewAll: '전체 공지 보기',
      dialogTitle: '전체 공지',
      dialogDesc: '공지 제목을 선택하면 레이어에서 본문 전체를 바로 확인할 수 있습니다.',
      loadingBody: '공지사항 본문을 불러오는 중입니다.',
      loadError: '공지사항 내용을 불러오는데 실패했습니다.',
      noneSelected: '선택된 공지사항이 없습니다.',
      close: '닫기',
    },
    hero: {
      badge: 'AI 기반 접근성 개선 어시스턴트',
      titleLine1: '이미지 ALT 텍스트를',
      titleLine2: '자동으로 생성하세요',
      subtitle1: '저시력자, 시각장애인을 위한 필수 웹 접근성 + 구글/네이버 검색 상위 노출',
      subtitle2a: '웹사이트 크롤링, 이미지 URL, 이미지 업로드, API 연동 등 다양한 방식으로 이미지 ALT 텍스트를 자동 생성하세요',
      subtitle2b: '단순히 AI에 사진을 보여주는 것과 차원이 다릅니다. 업종·사이트 유형·브랜드 톤이 반영된 맞춤형 ALT를 웹사이트 전체에 한 번에 적용하세요.',
      ctaStart: '무료로 시작하기',
      ctaDiagnose: '내 사이트 무료 진단',
    },
    beforeAfter: {
      heading: '실제 개선 효과',
      sub: 'AI가 생성한 ALT 텍스트로 접근성과 SEO가 동시에 개선됩니다',
      beforeLabel: '개선 전',
      afterLabel: '개선 후',
      afterCode: '검은색 스포츠카가 도로를 달리는 모습',
      beforeItems: ['ALT 텍스트 없음', '접근성 개선 필요', 'SEO 개선 필요'],
      afterItems: ['AI 생성 ALT 텍스트', '접근성 개선 완료', 'SEO 개선 완료'],
    },
    diagnosePromo: {
      badge: '회원가입 없이 무료 · 하루 3회',
      headingLine1: '내 사이트',
      headingHighlight: '접근성 & SEO',
      headingLine2: '지금 바로',
      headingLine3: '무료 진단',
      desc1: 'URL 하나만 입력하면 KWCAG 2.2 기준 ',
      descStrong1: '24개 접근성 항목',
      desc2: '과',
      descStrong2: 'SEO 이미지 최적화',
      desc3: '를 AI가 자동 분석합니다. 로그인 없이, 즉시 결과를 확인하세요.',
      features: [
        'KWCAG 2.2 접근성 24개 항목 자동 검사',
        'Google PSI 기반 SEO 이미지 최적화 분석',
        'ALT 품질 평가 (0~100점)',
        '접근성·SEO 점수 + 이슈별 수정 가이드',
      ],
      ctaStart: '무료 진단 시작하기',
      ctaNote: '신용카드 불필요 · 즉시 결과 확인',
      mockUrl: 'https://www.yoursite.com',
      mockDone: '진단 완료',
      scoreLabels: ['접근성 점수', 'SEO 점수'],
      issuesLabel: '발견된 주요 이슈',
      issues: [
        { severity: 'error', text: 'ALT 없는 이미지 12개 발견', impact: '-10점' },
        { severity: 'error', text: '링크 내 빈 ALT 이미지 3개', impact: '-10점' },
        { severity: 'warning', text: 'H1 태그 없음 — 제목 구조 불량', impact: '-3점' },
        { severity: 'warning', text: 'OG 이미지 미설정 — SNS 공유 불이익', impact: '-3점' },
        { severity: 'info', text: 'target="_blank" 경고 미표시 링크', impact: '-1점' },
      ],
      severityLabels: { error: '오류', warning: '경고', info: '정보' },
      mockCta1: 'ALT 자동생성 가능 이미지 12개',
      mockCta2: 'AI로 즉시 수정',
    },
    features: {
      cards1: [
        { title: '웹사이트 크롤링', desc: 'URL만 입력하면 모든 이미지를 AI로 스캔하여 기존 ALT과 AI 생성 ALT를 함께 비교·제공합니다. 기존 ALT가 있는 이미지도 AI가 재분석합니다.' },
        { title: '이미지 URL 입력', desc: '이미지 URL을 직접 입력하여, 개별 이미지에 대한 ALT 텍스트를 빠르게 생성합니다.' },
        { title: '이미지 업로드', desc: '로컬 이미지 파일을 드래그 앤 드롭하거나 업로드하여 ALT 텍스트를 생성합니다.' },
      ],
      cards2: [
        { title: '빠른 생성', desc: 'AI 기술을 이용한 초고속 ALT 텍스트 생성으로 시간과 비용을 절감합니다.' },
        { title: '안전한 관리', desc: '엔터프라이즈급 보안으로 데이터를 보호하고 안전하게 관리합니다.' },
        { title: '맞춤형 결과', desc: '컨텍스트 프로필로 업종·톤·브랜드에 맞는 ALT 텍스트를 자동 생성합니다.' },
      ],
    },
    integrationMethods: {
      badge: '연동 방식 자세히 보기',
      heading: '당신의 워크플로에 맞는 방법을 고르세요',
      sub: '개발 리소스가 있든 없든, 자체 시스템이든 쇼핑몰 플랫폼이든 — 4가지 방식 중 하나는 지금 바로 적용할 수 있습니다.',
      cards: [
        {
          badge: '개발자용 · API',
          title: 'API 직접 연동',
          headline: '코드 몇 줄로 ALT 자동화를 파이프라인에 통합',
          bullets: [
            'Node.js · Java · Python 샘플 코드로 5분 연동',
            'API 키 기반 인증, 배치·대량 이미지 처리 지원',
            '자체 CMS·백오피스·크롤러 파이프라인에 그대로 삽입',
          ],
          cta: 'API 문서 보기',
          stat: '5분 연동',
        },
        {
          badge: '노코드 · 스니펫',
          title: 'JS 스니펫',
          headline: '스크립트 태그 한 줄로 페이지 전체를 자동 처리',
          bullets: [
            '별도 서버·배포 없이 <script> 태그만 삽입',
            '페이지에 새로 추가되는 이미지도 자동 감지·생성',
            '워드프레스 등 대부분의 CMS·노코드 빌더에 삽입 가능',
          ],
          cta: '스니펫 가이드 보기',
          stat: '설치 1줄',
        },
        {
          badge: '누구나 · 브라우저 확장',
          title: '크롬 웹스토어',
          headline: '설치 한 번이면 어떤 웹페이지든 생성 버튼이 생깁니다',
          bullets: [
            '개발 지식 없이 크롬 웹스토어에서 바로 설치',
            '기존에 쓰던 관리자 화면을 그대로 열고 버튼만 클릭',
            'Chrome·Edge 등 크로미움 기반 브라우저 전부 지원',
          ],
          cta: '확장프로그램 가이드 보기',
          stat: '무설치 서버',
          previewLabel: 'ALT 생성',
          previewNote: '페이지 어디서든 이 버튼 하나로 끝',
        },
        {
          badge: '쇼핑몰 특화 · 8개 플랫폼',
          title: '쇼핑몰 ALT 연동',
          headline: '상품 등록 화면에 최적화된 전용 확장프로그램',
          bullets: [
            'Cafe24·고도몰·아임웹·Make#·플레이오토·Shopify·삽링커·스마트스토어 지원',
            '대표이미지 + 상세설명 이미지 ALT까지 한 번에 일괄 생성',
            '상품명 기반 컨텍스트 반영, 이미 ALT 있는 이미지는 자동 건너뜀',
          ],
          cta: '쇼핑몰 확장 가이드 보기',
          stat: '8개 플랫폼',
          previewNote: '상세설명 이미지 ALT 일괄 생성',
        },
      ],
      codeComment: '이 한 줄이면 끝',
      codeResult: '페이지 내 모든 이미지 ALT 자동 적용',
    },
    aiComparison: {
      badge: '💡 솔직한 비교',
      heading: '"ChatGPT에 물어보면 되지 않나요?"',
      sub: '물론 가능합니다. 하지만 ',
      subStrong: '실무에서 쓰려면',
      subEnd: ' 이런 문제가 생깁니다.',
      leftTitle: '일반 AI 단독 사용',
      leftItems: [
        '이미지 1장씩 직접 복사·붙여넣기',
        '매번 업종·톤·길이 프롬프트를 다시 작성',
        '100개 이미지 = 100번 반복 작업',
        '결과를 따로 저장·정리해야 함',
        '개발 시스템·CMS 자동화 연동 불가',
        '사이트 전체 ALT 누락 현황 파악 불가',
        '영문 페이지 대응 시 언어 설정 매번 필요',
      ],
      rightBadge: '추천',
      rightTitle: 'ALT Generation',
      rightItems: [
        'URL 하나로 사이트 전체 이미지 일괄 처리',
        '컨텍스트 프로필 1회 설정 → 모든 요청에 자동 반영',
        'ALT 누락 이미지만 골라 배치 생성',
        '이력 저장 + HTML alt 태그 원클릭 복사',
        'REST API로 CMS·쇼핑몰에 직접 자동화',
        '사이트 전체 ALT 현황 대시보드 제공',
        '영문(eng) 출력 옵션으로 다국어 즉시 대응',
      ],
      bottomNote1: '💬 핵심 차이: 일반 AI는 ',
      bottomStrong1: '대화 도구',
      bottomNote2: '이고, ALT Generation은 ',
      bottomStrong2: 'ALT 전용 업무 자동화 플랫폼',
      bottomNote3: '입니다.',
    },
    contextProfile: {
      badge: '핵심 차별화 기능',
      headingLine1: '"우리 사이트에 맞는"',
      headingHighlight: '컨텍스트 프로필',
      desc1: '업종·사이트 유형·출력 톤을 ',
      descStrong1: '한 번만 설정',
      desc2: '하면, 이후 모든 ALT 생성에 자동으로 반영됩니다. 같은 이미지라도 ',
      descStrong2: '쇼핑몰',
      desc3: '과 ',
      descStrong3: '의료 사이트',
      desc4: '에서 전혀 다른 ALT가 나와야 합니다.',
      items: [
        { icon: '🏪', title: '업종 유형 설정', desc: '패션·전자·의료·금융 등 업종별 전문 용어 자동 반영' },
        { icon: '🎯', title: '서비스 대상 설정', desc: '일반 소비자 / 전문가 / 시니어 등 독자 수준에 맞는 표현' },
        { icon: '📏', title: '길이·문체 제어', desc: '짧고 간결 / 상세 설명 / 존댓말 등 브랜드 톤 일관성 유지' },
        { icon: '🚫', title: '금지어·필수어 설정', desc: '특정 단어 제외 또는 항상 포함되도록 강제 적용' },
      ],
      mockTitle: '컨텍스트 프로필 예시',
      mockSubtitle: '패션 쇼핑몰 설정',
      mockRows: [
        { label: '업종', value: '패션/의류' },
        { label: '사이트 유형', value: '쇼핑몰' },
        { label: '서비스 대상', value: '20~40대 여성' },
        { label: '출력 톤', value: '친근하고 감성적인' },
        { label: '길이 제한', value: '50자 이내' },
        { label: '종결 어미', value: '명사형 (~있습니다)' },
        { label: '필수 포함어', value: '신상품, 세일' },
        { label: '금지어', value: '저렴한, 싸구려' },
      ],
      exampleLabel: '🤖 실제 생성 예시',
      exampleText: '"감각적인 플로럴 패턴의 봄 신상품 원피스, 우아하고 세련된 디자인"',
    },
    benefits: {
      headingLine1: '투자 대비 효과가',
      headingLine2: '명확합니다',
      items: [
        { title: '웹 접근성 개선 지원', desc: '국내 장애인차별금지법·전자정부법, 해외 WCAG 2.1 기준에서 요구하는 이미지 대체텍스트 작성을 자동화해 접근성 개선을 지원합니다. 스크린 리더 사용자가 이미지를 이해하는 데 도움을 줍니다.' },
        { title: 'SEO 이미지 검색 노출 증가', desc: 'Google 이미지 검색은 ALT 텍스트를 핵심 신호로 활용합니다. 업종 키워드가 반영된 ALT로 이미지 검색 유입을 늘리세요.' },
        { title: '반복 작업 90% 자동화', desc: '담당자가 이미지 1장에 평균 2~3분 쏟는 ALT 작업을 초 단위로 줄입니다. 월 2,000장이면 약 100시간의 인건비를 절감합니다.' },
        { title: '브랜드 일관성 유지', desc: '컨텍스트 프로필로 항상 동일한 톤·용어·길이로 생성됩니다. 담당자가 바뀌어도 ALT 품질이 흔들리지 않습니다.' },
      ],
      stats: [
        { value: '10,000+', badge: '목표', label: '생성된 ALT 텍스트' },
        { value: '500+', badge: '목표', label: '활성 사용자' },
        { value: '99.9%', label: '서비스 가용성' },
      ],
      statsNote: '* 목표 수치는 2026년 말 기준입니다.',
    },
    useCases: {
      heading: '이런 분들께 꼭 필요합니다',
      sub: '업종과 역할에 따라 ALT Generation이 해결해주는 문제가 다릅니다.',
      cards: [
        {
          emoji: '🛍️', title: '쇼핑몰·이커머스',
          desc: '수천 개 상품 이미지에 일일이 ALT를 쓰고 있나요? 크롤링 한 번으로 전체 상품 이미지 ALT를 자동 생성, SEO 순위를 높이세요.',
          bullets: ['상품명·소재 기반 정확한 ALT', '신규 상품 등록 시 API 자동화', '누락 ALT 대시보드로 즉시 확인'],
        },
        {
          emoji: '📰', title: '뉴스·미디어·블로그',
          desc: '매일 수십 건의 기사와 이미지를 발행합니다. 기자·편집자가 ALT에 시간을 쏟는 대신, 자동화로 접근성을 지키세요.',
          bullets: ['기사 맥락에 맞는 간결한 ALT', 'CMS API 연동으로 발행 즉시 적용', '웹 접근성 개선 지원'],
        },
        {
          emoji: '🏢', title: '기업 웹팀·에이전시',
          desc: '여러 클라이언트 사이트의 ALT를 관리합니다. 사이트마다 다른 프로필을 설정하고, 팀원들이 일관된 품질로 작업하세요.',
          bullets: ['클라이언트별 브랜드 톤 프로필 저장', '이미지 업로드 배치 처리', '관리자 대시보드·사용 현황 리포트'],
        },
      ],
    },
    pricing: {
      heading: '합리적인 요금제',
      sub: '필요에 맞는 플랜을 선택하세요. 언제든지 업그레이드하거나 다운그레이드할 수 있습니다.',
      perMonth: '/월',
      startButton: '시작하기',
      contactButton: '문의하기',
      popularBadge: '인기',
      plans: [
        { id: 'free', name: '무료', price: '₩0', popular: false, contact: false, features: ['월 40개 이미지', '기본 기능'] },
        { id: 'starter', name: '스타트', price: '₩9,900', popular: false, contact: false, features: ['월 1,000개 이미지', '모든 기능', '서비스 지원', 'API 접근'] },
        { id: 'pro', name: '프로', price: '₩29,000', popular: true, contact: false, features: ['월 5,000개 이미지', '모든 기능', '우선 지원', 'API 접근'] },
        { id: 'enterprise', name: '엔터프라이즈', price: '문의', popular: false, contact: true, features: ['5천건 초과 단가 할인', '대량 사용 누진 요금제', '맞춤 기능', '전담 매니저', 'SLA 보장'] },
      ],
    },
    about: {
      heading: 'ALT Generation 소개',
      p1: 'ALT Generation은 웹 접근성과 SEO 최적화를 위한 혁신적인 AI 솔루션을 제공합니다. 우리의 목표는 모든 웹사이트가 더 접근성 높고, 더 검색 친화적이 되도록 돕는 것입니다.',
      p2: '2016년에 설립된 저희 회사는 최첨단 AI 기술을 활용하여 이미지 ALT 텍스트 생성을 자동화하고, 웹 개발자와 콘텐츠 제작자들이 더 나은 디지털 경험을 만들 수 있도록 지원합니다.',
      infoHeading: '회사 정보',
      labels: { name: '상호명', ceo: '대표이사', bizNum: '사업자등록번호', founded: '설립일' },
      values: { name: '(주)지호아이앤씨', ceo: '최정윤', bizNum: '849-81-00345', founded: '2016년 4월' },
    },
    cta: {
      heading: '지금 바로 시작하세요',
      desc: '무료로 시작하고 AI 기반 ALT 텍스트 생성의 강력함을 경험해보세요.',
      ctaStart: '무료로 시작하기',
      ctaContact: '문의하기',
    },
  },
  en: {
    meta: {
      title: 'ALT Generation - AI-Powered Image Alt Text Generator',
      description: 'Generate image alt text automatically with AI. An image alt text automation service that solves web accessibility compliance and SEO at the same time.',
    },
    notice: {
      badge: 'Notice',
      viewAll: 'View all notices',
      dialogTitle: 'All notices',
      dialogDesc: 'Select a notice title to read the full content right here.',
      loadingBody: 'Loading notice content…',
      loadError: 'Failed to load the notice content.',
      noneSelected: 'No notice selected.',
      close: 'Close',
    },
    hero: {
      badge: 'AI-powered accessibility assistant',
      titleLine1: 'Automatically generate',
      titleLine2: 'image ALT text',
      subtitle1: 'Essential web accessibility for low-vision and blind users + higher rankings on Google/Naver image search',
      subtitle2a: 'Generate image ALT text automatically via website crawling, image URLs, image upload, or API integration',
      subtitle2b: "This is not just showing a photo to an AI. Apply custom ALT text — tailored to your industry, site type, and brand tone — across your entire site at once.",
      ctaStart: 'Start for Free',
      ctaDiagnose: 'Free Site Diagnosis',
    },
    beforeAfter: {
      heading: 'Real Improvement Results',
      sub: 'AI-generated ALT text improves accessibility and SEO at the same time',
      beforeLabel: 'Before',
      afterLabel: 'After',
      afterCode: 'A black sports car driving down the road',
      beforeItems: ['No ALT text', 'Accessibility needs improvement', 'SEO needs improvement'],
      afterItems: ['AI-generated ALT text', 'Accessibility improved', 'SEO improved'],
    },
    diagnosePromo: {
      badge: 'Free, no sign-up · 3 per day',
      headingLine1: 'Diagnose your site’s',
      headingHighlight: 'accessibility & SEO',
      headingLine2: 'right now,',
      headingLine3: 'for free',
      desc1: 'Just enter a URL and AI automatically analyzes ',
      descStrong1: '24 KWCAG 2.2 accessibility items',
      desc2: ' and ',
      descStrong2: 'SEO image optimization',
      desc3: '. See results instantly, no login required.',
      features: [
        'Automatic check of 24 KWCAG 2.2 accessibility items',
        'SEO image optimization analysis based on Google PSI',
        'ALT quality score (0–100)',
        'Accessibility/SEO scores + per-issue fix guides',
      ],
      ctaStart: 'Start Free Diagnosis',
      ctaNote: 'No credit card required · instant results',
      mockUrl: 'https://www.yoursite.com',
      mockDone: 'Diagnosis complete',
      scoreLabels: ['Accessibility Score', 'SEO Score'],
      issuesLabel: 'Key issues found',
      issues: [
        { severity: 'error', text: '12 images found without ALT text', impact: '-10 pts' },
        { severity: 'error', text: '3 images with empty ALT inside links', impact: '-10 pts' },
        { severity: 'warning', text: 'Missing H1 tag — poor heading structure', impact: '-3 pts' },
        { severity: 'warning', text: 'OG image not set — hurts social sharing', impact: '-3 pts' },
        { severity: 'info', text: 'Links missing target="_blank" warning', impact: '-1 pt' },
      ],
      severityLabels: { error: 'Error', warning: 'Warning', info: 'Info' },
      mockCta1: '12 images eligible for auto ALT generation',
      mockCta2: 'Fix instantly with AI',
    },
    features: {
      cards1: [
        { title: 'Website Crawling', desc: "Enter just a URL and AI scans every image, comparing existing ALT text with AI-generated ALT side by side. AI re-analyzes images that already have ALT text, too." },
        { title: 'Image URL Input', desc: 'Enter an image URL directly to quickly generate ALT text for a single image.' },
        { title: 'Image Upload', desc: 'Drag and drop or upload local image files to generate ALT text.' },
      ],
      cards2: [
        { title: 'Fast Generation', desc: 'Ultra-fast AI-powered ALT text generation saves time and cost.' },
        { title: 'Secure by Design', desc: 'Enterprise-grade security protects and manages your data safely.' },
        { title: 'Tailored Results', desc: 'Context profiles automatically generate ALT text matched to your industry, tone, and brand.' },
      ],
    },
    integrationMethods: {
      badge: 'See integration methods in detail',
      heading: 'Pick the method that fits your workflow',
      sub: "Whether or not you have dev resources, whether it's your own system or a storefront platform — one of these 4 methods works for you right now.",
      cards: [
        {
          badge: 'For developers · API',
          title: 'Direct API Integration',
          headline: 'Integrate ALT automation into your pipeline in a few lines of code',
          bullets: [
            'Connect in 5 minutes with Node.js · Java · Python sample code',
            'API key authentication, batch/bulk image processing supported',
            'Drop straight into your own CMS, back office, or crawler pipeline',
          ],
          cta: 'View API Docs',
          stat: '5-min setup',
        },
        {
          badge: 'No-code · Snippet',
          title: 'JS Snippet',
          headline: 'Automate the entire page with a single script tag',
          bullets: [
            'Just insert a <script> tag — no server or deployment needed',
            'Automatically detects and generates ALT for newly added images too',
            'Works with WordPress and most CMS/no-code builders',
          ],
          cta: 'View Snippet Guide',
          stat: '1-line install',
        },
        {
          badge: 'For anyone · Browser extension',
          title: 'Chrome Web Store',
          headline: 'Install once and get a generate button on any webpage',
          bullets: [
            'Install directly from the Chrome Web Store, no dev knowledge needed',
            'Keep using your existing admin screen — just click the button',
            'Works on Chrome, Edge, and other Chromium-based browsers',
          ],
          cta: 'View Extension Guide',
          stat: 'No server install',
          previewLabel: 'Generate ALT',
          previewNote: 'One button, anywhere on the page',
        },
        {
          badge: 'Storefront-specific · 8 platforms',
          title: 'Storefront ALT Integration',
          headline: 'A dedicated extension optimized for product registration screens',
          bullets: [
            'Supports Cafe24, Godo Mall, Imweb, Make#, Playauto, Shopify, Sablink, Naver Smartstore',
            'Bulk-generate ALT for main + detail description images at once',
            'Uses product name as context; automatically skips images that already have ALT',
          ],
          cta: 'View Storefront Extension Guide',
          stat: '8 platforms',
          previewNote: 'Bulk ALT generation for detail description images',
        },
      ],
      codeComment: 'That’s all it takes',
      codeResult: 'ALT applied automatically to every image on the page',
    },
    aiComparison: {
      badge: '💡 An honest comparison',
      heading: '"Can’t I just ask ChatGPT?"',
      sub: 'Sure, you can. But ',
      subStrong: 'using it in real production work',
      subEnd: ' runs into these problems.',
      leftTitle: 'Using a general AI alone',
      leftItems: [
        'Copy and paste images one by one',
        'Rewrite the industry/tone/length prompt every single time',
        '100 images = 100 repeated manual tasks',
        'Have to save and organize the results yourself',
        'No automation with dev systems or CMS',
        'No way to see site-wide missing-ALT status',
        'Have to reset the language setting every time for English pages',
      ],
      rightBadge: 'Recommended',
      rightTitle: 'ALT Generation',
      rightItems: [
        'Process every image on a site in bulk from a single URL',
        'Set up a context profile once → applied automatically to every request',
        'Batch-generate only for images missing ALT text',
        'History saved + one-click copy of the HTML alt tag',
        'Direct automation into your CMS/storefront via REST API',
        'Site-wide ALT status dashboard included',
        'Instant multilingual support with the English output option',
      ],
      bottomNote1: '💬 The key difference: general AI is a ',
      bottomStrong1: 'conversation tool',
      bottomNote2: ', while ALT Generation is a ',
      bottomStrong2: 'dedicated ALT workflow automation platform',
      bottomNote3: '.',
    },
    contextProfile: {
      badge: 'Our key differentiator',
      headingLine1: '"Tailored to your site"',
      headingHighlight: 'Context Profiles',
      desc1: 'Set your industry, site type, and output tone ',
      descStrong1: 'just once',
      desc2: ' and it’s applied automatically to every ALT generation after that. The same image should get completely different ALT text on a ',
      descStrong2: 'storefront',
      desc3: ' versus a ',
      descStrong3: 'healthcare site',
      desc4: '.',
      items: [
        { icon: '🏪', title: 'Industry type', desc: 'Automatically applies industry-specific terminology for fashion, electronics, healthcare, finance, and more' },
        { icon: '🎯', title: 'Target audience', desc: 'Match wording to your readers — general consumers, professionals, seniors, and more' },
        { icon: '📏', title: 'Length & tone control', desc: 'Keep brand tone consistent — short and concise, detailed, formal, and more' },
        { icon: '🚫', title: 'Required/forbidden words', desc: 'Force certain words to be excluded, or always included' },
      ],
      mockTitle: 'Sample Context Profile',
      mockSubtitle: 'Fashion storefront setup',
      mockRows: [
        { label: 'Industry', value: 'Fashion/Apparel' },
        { label: 'Site type', value: 'Storefront' },
        { label: 'Target audience', value: 'Women, 20s–40s' },
        { label: 'Output tone', value: 'Friendly and emotive' },
        { label: 'Length limit', value: 'Under 50 characters' },
        { label: 'Sentence ending', value: 'Noun form' },
        { label: 'Required words', value: 'New arrival, sale' },
        { label: 'Forbidden words', value: 'Cheap, low-quality' },
      ],
      exampleLabel: '🤖 Actual generated example',
      exampleText: '"A stylish floral-print spring dress, elegant and refined design"',
    },
    benefits: {
      headingLine1: 'The return on investment',
      headingLine2: 'is clear',
      items: [
        { title: 'Web accessibility support', desc: "Automates image alt text as required by Korea's Anti-Discrimination Against and Remedies for Persons with Disabilities Act and Electronic Government Act, as well as international WCAG 2.1, helping screen reader users understand your images." },
        { title: 'Increased SEO image search visibility', desc: 'Google Image Search uses ALT text as a key ranking signal. Drive more image search traffic with ALT text that reflects your industry keywords.' },
        { title: '90% of repetitive work automated', desc: 'Cuts the 2–3 minutes staff typically spend per image down to seconds. At 2,000 images a month, that saves roughly 100 hours of labor.' },
        { title: 'Consistent brand voice', desc: 'Context profiles always generate the same tone, terminology, and length — so ALT quality stays consistent even as staff change.' },
      ],
      stats: [
        { value: '10,000+', badge: 'Target', label: 'ALT texts generated' },
        { value: '500+', badge: 'Target', label: 'Active users' },
        { value: '99.9%', label: 'Service uptime' },
      ],
      statsNote: '* Target figures are as of end of 2026.',
    },
    useCases: {
      heading: 'Built for teams like yours',
      sub: 'The problem ALT Generation solves depends on your industry and role.',
      cards: [
        {
          emoji: '🛍️', title: 'Retail & E-commerce',
          desc: 'Still writing ALT text for thousands of product images by hand? One crawl automatically generates ALT for every product image and boosts your SEO ranking.',
          bullets: ['Accurate ALT based on product name and material', 'API automation whenever a new product is listed', 'Instantly check missing ALT via dashboard'],
        },
        {
          emoji: '📰', title: 'News, Media & Blogs',
          desc: 'You publish dozens of articles and images every day. Instead of reporters and editors spending time on ALT text, keep accessibility with automation.',
          bullets: ['Concise ALT that fits the article context', 'Applied instantly on publish via CMS API integration', 'Ongoing web accessibility support'],
        },
        {
          emoji: '🏢', title: 'Corporate Web Teams & Agencies',
          desc: 'Managing ALT text across multiple client sites? Set a different profile per site and keep your whole team’s output consistent.',
          bullets: ['Save a brand-tone profile per client', 'Batch processing for image uploads', 'Admin dashboard with usage reports'],
        },
      ],
    },
    pricing: {
      heading: 'Straightforward Pricing',
      sub: 'Pick the plan that fits your needs. Upgrade or downgrade anytime.',
      perMonth: '/mo',
      startButton: 'Get Started',
      contactButton: 'Contact Us',
      popularBadge: 'Popular',
      plans: [
        { id: 'free', name: 'Free', price: '₩0', popular: false, contact: false, features: ['40 images/month', 'Core features'] },
        { id: 'starter', name: 'Starter', price: '₩9,900', popular: false, contact: false, features: ['1,000 images/month', 'All features', 'Standard support', 'API access'] },
        { id: 'pro', name: 'Pro', price: '₩29,000', popular: true, contact: false, features: ['5,000 images/month', 'All features', 'Priority support', 'API access'] },
        { id: 'enterprise', name: 'Enterprise', price: 'Contact us', popular: false, contact: true, features: ['Volume discount above 5,000/mo', 'Progressive volume pricing', 'Custom features', 'Dedicated manager', 'SLA guarantee'] },
      ],
    },
    about: {
      heading: 'About ALT Generation',
      p1: 'ALT Generation provides an innovative AI solution for web accessibility and SEO optimization. Our goal is to help every website become more accessible and more search-friendly.',
      p2: 'Founded in 2016, our company uses cutting-edge AI technology to automate image ALT text generation, helping web developers and content creators build better digital experiences.',
      infoHeading: 'Company Information',
      labels: { name: 'Company Name', ceo: 'CEO', bizNum: 'Business Registration No.', founded: 'Founded' },
      values: { name: 'JIHO I&C Co., Ltd.', ceo: 'Choi Jeong-yun', bizNum: '849-81-00345', founded: 'April 2016' },
    },
    cta: {
      heading: 'Get Started Right Now',
      desc: 'Start for free and experience the power of AI-driven ALT text generation.',
      ctaStart: 'Start for Free',
      ctaContact: 'Contact Us',
    },
  },
} as const;

export type LandingCopy = typeof landingCopy.ko;
